// extracted by mini-css-extract-plugin
export var blockForm = "BlockForm_blockForm__0XCg3";
export var btnCreate = "BlockForm_btnCreate__Dv5sp";